// services/schedule.ts
import axios from 'axios';
import api from './api';
import { Schedule, Member, VendorMember, Car, Construction } from '../types/schedule';
import { useUser } from '../hooks/useUser';

export const scheduleService = {
  
  // スケジュール関連
  async getSchedulesByDateRange(startDate: string, endDate: string) {
    const response = await api.get(`/schedules/range`, {
      params: { startDate, endDate }
    });
    // 常に工事予定として扱う
    if (response.data && response.data.schedules) {
      response.data.schedules = response.data.schedules.map((schedule: any) => ({
        ...schedule,
        type: 'construction' // 明示的に工事予定タイプを設定
      }));
    }
    
    return response.data;
  },

  async getScheduleById(id: number) {
    const response = await api.get(`/schedules/${id}`);
    return response.data;
  },

  async createSchedule(scheduleData: Schedule) {
    const response = await api.post(`/schedules/create`, {
      constructionId: scheduleData.constructionId,
      scheduleDate: scheduleData.scheduleDate,
      startTime: scheduleData.startTime,
      endTime: scheduleData.endTime,
      meetingTime: scheduleData.meetingTime,
      isAllDay: scheduleData.isAllDay,
      notes: scheduleData.notes,
      createdBy: localStorage.getItem('lastName') || 'system',
      memberData: scheduleData.memberData,
      vehicleData: scheduleData.vehicleData,
      teamType: scheduleData.teamType,
      requiredWorkers: scheduleData.requiredWorkers
    });
    return response.data;
  },

  async updateSchedule(id: number, scheduleData: Partial<Schedule>) {
    const response = await api.put(`/schedules/${id}`, {
      constructionId: scheduleData.constructionId,
      scheduleDate: scheduleData.scheduleDate,
      startTime: scheduleData.startTime,
      endTime: scheduleData.endTime,
      meetingTime: scheduleData.meetingTime,
      isAllDay: scheduleData.isAllDay,
      notes: scheduleData.notes,
      memberData: scheduleData.memberData,
      vehicleData: scheduleData.vehicleData,
      teamType: scheduleData.teamType,
      requiredWorkers: scheduleData.requiredWorkers
    });
    return response.data;
  },

  async deleteSchedule(id: number) {
    const response = await api.delete(`/schedules/${id}`);
    return response.data;
  },

  // 未完了工事データを取得
  async getIncompleteConstructions() {
    const response = await api.get(`/schedules/incomplete-constructions`);
    return response.data.constructions as Construction[];
  },

  // 工事に紐づく担当者を取得
  async getConstructionMembers(constructionId: number) {
    const response = await api.get(`/schedules/construction-members/${constructionId}`);
    return response.data.members;
  },

  // マスターデータ関連
  async getMembers() {
    const response = await api.get(`/members/list`);
    return response.data as Member[];
  },

  async getVendorMembers() {
    const response = await api.get(`/vendors/members/list`);
    return response.data as VendorMember[];
  },

  async getCars() {
    const response = await api.get(`/cars/list`);
    return response.data as Car[];
  },

  async getConstructions() {
    const response = await api.get(`/constructions`);
    return response.data as Construction[];
  }
};